<template>
  <AppLayout>
    <div class="pricing-header px-3 py-6 pt-md-5 mx-auto text-center">
        <h1 class="display-4">Kinnisturegistri päringud</h1>
    </div>
    <admin-real-estate-component></admin-real-estate-component>
  </AppLayout>
</template>

<script setup>
import AdminRealEstateComponent from '@/components/admin/AdminRealEstateComponent.vue'
import AppLayout from '../../Layouts/AppLayout.vue'
</script>
